import { match } from 'path-to-regexp';

export const matchPath = (path: string, pathname: string) => {
	const fn = match(path);
	return fn(pathname);
};
